import Vue from 'vue'
import VueRouter from 'vue-router'

import home from "@/views/Public/home";
import ourStory from "@/views/Public/ourStory";
import Login from "@/views/Public/Login";
import aboutUs from "@/views/Public/aboutUs";
import time from "@/views/Public/time";
import ourSpace from "@/views/Public/ourSpace";
import noZone from "@/views/Public/noZone";
import successfulMaster from "@/views/Public/successfulMaster";

Vue.use(VueRouter)

const routes = [
  {
    path:'/home',
    component:home
  },
  {
    path:'/Login',
    component:Login
  },
  {
    path:'/ourStory',
    component:ourStory
  },
  {
    path: '/',
    redirect:'/Login'
  },
  {
    path:'/aboutUs',
    component:aboutUs
  },
  {
    path:'/time',
    component:time
  },
  {
    path:'/ourSpace',
    component:ourSpace
  },
  {
    path:"/noZone",
    component:noZone
  },
  {
    path:"/successfulMaster",
    component:successfulMaster
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
